import { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from '../services/axiosService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInStatus = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedInStatus);
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axiosInstance.post('/api/admin/login', {
        username,
        password
      });
      
      if (response.data && response.data.data.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('isLoggedIn', 'true');
        if (response.data.data.data) {
          setUser(response.data.data);
        }
        toast.success(response.data.message);
        setIsLoggedIn(true);
        return true;
      }
      toast.error(response.data.message);
      return false;
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.message || 'Đăng nhập thất bại. Vui lòng thử lại sau.';
      toast.error(errorMessage);
      return false;
    }
  };

  const logout = async () => {
    try {
      // Optional: Call logout endpoint if available
      // await axiosInstance.post('/api/admin/logout');
      toast.success('Đăng xuất thành công');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('isLoggedIn');
      setUser(null);
      setIsLoggedIn(false);
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, loading, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
